import { Box, Typography } from "@mui/material";

import { BrazeContentCard } from "../../../services/braze/braze.types";
import BrazeNotificationCard from "./BrazeNotificationCard";
import { Notification } from "../../../services/notifications/notifications-interface";
import NotificationCard from "./NotificationCard";
import { NotificationCardContainerStyle }
  from "./Notification.style";
import { NotificationFeedEntry } from "./notification-feed";
import NotificationNullState from "./Notification-null-state";
import React from "react";

type Props = {
  entries: NotificationFeedEntry[]
  handleCTA: (notification: Notification) => void;
  getIcon: (notification: Notification) => string;
  handleSingleNotificationRead?: (notificationId: string, notificationType:string) => void;
  handleMarkAllRead?: () => void;
  logCardImpression: (card: BrazeContentCard) => void;
  logCardClick: (card: BrazeContentCard) => void;
}

const LatestNotification = (props: Props) => {
  const { entries, handleCTA, getIcon, handleSingleNotificationRead, handleMarkAllRead,
    logCardImpression, logCardClick } = props;

  return (
    <>
      <Box sx={NotificationCardContainerStyle}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="body1" fontWeight={600}>Latest</Typography>
          <Typography variant="body1" sx={{ cursor: "pointer" }}
            onClick={handleMarkAllRead}>Mark all as read</Typography>
        </Box>
        {entries.length === 0 && <NotificationNullState
          title={"No new notifications"}/>}
        {entries.map((entry: NotificationFeedEntry, index: number)=>(
          entry.kind === "braze" ? (
            <BrazeNotificationCard
              key={entry.card.id || `braze-${index}`}
              card={entry.card}
              logImpression={logCardImpression}
              logClick={logCardClick}
            />
          ) : (
            <NotificationCard
              key={entry.notification.notificationMessageId || `backend-${index}`}
              notification={entry.notification}
              handleReadMessage={handleSingleNotificationRead}
              handleCTA={handleCTA}
              getIcon={getIcon}
            />
          )
        ))}
      </Box>
    </>
  );
};

export default LatestNotification;
